import React from "react";
import { useLocation } from 'react-router-dom';
import { HTMLTemplate } from "@minerva-analytics/pantheon";
import { LegalContainer } from './Legal.styles';
import { ShadowContentCard } from '../../styled_constants';

const commonInfo = {
  dba: `Starguide`,
  domain: `https://www.starguidehoroscopes.com`,
  email: `support@starlies.com`,
  name: `Starguide Support`,
  address1: `47 Waterbury Road`,
  address2: `Suite 4 PMB 364`,
  state: `Prospect, CT 06712`,
  country: `USA`,
};

const legalInfo = {
  "/ccpa": {
    templateUrl: `https://storage.googleapis.com/minerva-legal/CalPolicy.html`,
    variables: { ...commonInfo },
  },
  "/cookie": {
    templateUrl: `https://storage.googleapis.com/minerva-legal/CookiePolicy.html`,
    variables: { ...commonInfo },
  },
  "/terms": {
    templateUrl: `https://storage.googleapis.com/minerva-legal/Terms.html`,
    variables: { ...commonInfo },
  },
  "/privacy": {
    templateUrl: `https://storage.googleapis.com/minerva-legal/Privacy.html`,
    variables: { ...commonInfo },
  },
};

const Legal = () => {
  const { pathname } = useLocation();
  return (
    <ShadowContentCard>
      <LegalContainer>
        <HTMLTemplate {...legalInfo[pathname]} />
      </LegalContainer>
    </ShadowContentCard>
  );
};

export default Legal;
